const HOME: string = '/home';
const BLOCKS: string = '/blocks';
const TRANSACTION: string = '/transactions';
const SMART_CONTRACT: string = '/smart-contract';
const ROOT: string = '/';
const PAGE_NOT_FOUND: string = '*';

const path = {
  ROOT,
  HOME,
  BLOCKS,
  TRANSACTION,
  SMART_CONTRACT,
  PAGE_NOT_FOUND,
};

export default path;
